const types = {
  SET_PROGRAMS: "SET_PROGRAMS",
  ADD_OR_UPDATE_PROGRAM: " ADD_OR_UPDATE_PROGRAM",

  SET_SUB_PROGRAMS: "SET_SUB_PROGRAMS",
  ADD_OR_UPDATE_SUB_PROGRAM: " ADD_OR_UPDATE_SUB_PROGRAM",

  SET_TOPICS: "SET_TOPICS",
  ADD_OR_UPDATE_TOPIC: " ADD_OR_UPDATE_TOPIC",

  SET_ORGANIZATION_TYPES: "SET_ORGANIZATION_TYPES",
  ADD_OR_UPDATE_ORGANIZATION_TYPE: "ADD_OR_UPDATE_ORGANIZATION_TYPE",

  SET_TRAINING_PROVIDER_ATTACHMENT_TYPES:
    "SET_TRAINING_PROVIDER_ATTACHMENT_TYPES",
  ADD_OR_UPDATE_TRAINING_PROVIDER_ATTACHMENT_TYPE:
    "ADD_OR_UPDATE_TRAINING_PROVIDER_ATTACHMENT_TYPE",

  SET_TRAINING_PROVIDERS: "SET_TRAINING_PROVIDERS",

  ADD_OR_UPDATE_TRAINING_PROVIDER: "ADD_OR_UPDATE_TRAINING_PROVIDER",

  SET_VENUES: "SET_VENUES",
  ADD_OR_UPDATE_VENUE: " ADD_OR_UPDATE_VENUE",

  SET_TRAININGS: "SET_TRAININGS",
  ADD_OR_UPDATE_TRAINING: "ADD_OR_UPDATE_TRAINING",
  REMOVE_TRAINING: "REMOVE_TRAINING",

  SET_PROVIDER_PROGRAMS: "SET_PROVIDER_PROGRAMS",

  SET_TRAINEE_CATEGORIES: "SET_TRAINEE_CATEGORIES",
  ADD_OR_UPDATE_TRAINEE_CATEGORY: "ADD_OR_UPDATE_TRAINEE_CATEGORY",

  SET_TRAINER_CATEGORIES: "SET_TRAINER_CATEGORIES",
  ADD_OR_UPDATE_TRAINER_CATEGORY: "ADD_OR_UPDATE_TRAINER_CATEGORY",

  SET_TRAINERS: "SET_TRAINERS",
  ADD_OR_UPDATE_TRAINER: " ADD_OR_UPDATE_TRAINER",
  SET_PROGRAM_CATEGORIES: "SET_PROGRAM_CATEGORIES",

  SET_TRAINEE_SUB_CATEGORIES: "SET_TRAINEE_SUB_CATEGORIES",
  ADD_OR_UPDATE_TRAINEE_SUB_CATEGORY: "ADD_OR_UPDATE_TRAINEE_SUB_CATEGORY",
  SET_MEMBERSHIP_REQUESTS: "SET_MEMBERSHIP_REQUESTS",
  ADD_OR_UPDATE_MEMBERSHIP_REQUEST: "ADD_OR_UPDATE_MEMBERSHIP_REQUEST",
  SET_COUNTRIES: "SET_COUNTRIES",
  SET_VENUE_TYPES: "SET_VENUE_TYPES",
};

export default types;
